import { Box, IconButton, Tooltip } from '@chakra-ui/react'
import { MicOn, MicOff } from 'src/components/icon'

import { useLocalPlayer } from '../../context/localPlayerContext'
import { useVideoCallRoom } from '../../context/videoCallRoomContext'
import {
  ControlButtonType,
  getButtonSize,
  getIconSize,
  getIndicatorProps,
} from '../../utils/controlButtonUtil'
import { ErrorIndicatorIcon } from '../ErrorIndicatorIcon/ErrorIndicatorIcon'

type Props = {
  type?: ControlButtonType
  colorScheme?: 'blue' | 'green'
}

export const MicButton: React.FC<Props> = ({
  type = 'normal',
  colorScheme = 'blue',
}) => {
  const { roomStatus } = useVideoCallRoom()
  const {
    localMicrophoneEnabled,
    toggleLocalMicrophone,
    localMicrophoneError,
  } = useLocalPlayer()

  const buttonSize = getButtonSize(type)
  const iconSize = getIconSize(type)
  const indicatorProps = getIndicatorProps(type)

  return (
    <Tooltip
      label={
        localMicrophoneEnabled ? 'マイクをオフにする' : 'マイクをオンにする'
      }
    >
      <Box pos="relative">
        <IconButton
          aria-label={
            localMicrophoneEnabled ? 'マイクをオフにする' : 'マイクをオンにする'
          }
          variant="customIconButtonSolid"
          w={buttonSize}
          h={buttonSize}
          colorScheme={localMicrophoneEnabled ? colorScheme : 'red'}
          isDisabled={roomStatus === 'left'}
          icon={
            localMicrophoneEnabled ? (
              <MicOn size={iconSize} />
            ) : (
              <MicOff size={iconSize} />
            )
          }
          onClick={toggleLocalMicrophone}
        />
        {!!localMicrophoneError && <ErrorIndicatorIcon {...indicatorProps} />}
      </Box>
    </Tooltip>
  )
}
